import waveData from "../../data/waves.json";
import { IState, IwaveData } from "../types";
import { generateFromAbridgedBits } from "./bitFactory";
import { generateEntity } from "./entityFactory";

const { waves, startingBits } = waveData as IwaveData;

const [waveIndex, actorIndex] = [0, 0];
const pick = { wave: { index: waveIndex, actorIndex } };
const { battleDuration } = waves[waveIndex].actors[actorIndex + 1];

const initialState: IState = {
  turn: { global: 1, battle: 1, battleDuration },
  actors: [
    generateEntity(waves[waveIndex].actors[actorIndex]),
    generateEntity(waves[waveIndex].actors[actorIndex + 1])
  ],
  // we just generated 2 actors, so update pick accordingly
  pick: { ...pick, wave: { index: waveIndex, actorIndex: actorIndex + 1 } },
  screen: "#title",
  bits: generateFromAbridgedBits(startingBits),
  board: {
    points: 0,
    activeTiles: { whiteMagic0: true, root: true }
  },
  waves
};

export default initialState;
